// Generated by Melange

import * as Buhta_cabinet__Button from "../../../html/Button.js";
import * as Buhta_cabinet__ReceiptPanel from "../../../molecules/ReceiptPanel.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(param) {
  return function (receipt) {
    return function (onStartOverClicked) {
      return function (kkm) {
        return JsxRuntime.jsx("div", {
                    children: JsxRuntime.jsx(Buhta_cabinet__ReceiptPanel.make, {
                          receipt: receipt,
                          leftActions: {
                            hd: JsxRuntime.jsx(Buhta_cabinet__Button.make, {
                                  size: "s",
                                  onClick: (function (param) {
                                      Curry._1(onStartOverClicked, undefined);
                                    }),
                                  children: "На главную"
                                }),
                            tl: /* [] */0
                          },
                          className: "cashbox--receipt-panel",
                          kkm: kkm
                        }),
                    className: "cashbox-payment px-6 py-4 lg:p-0"
                  });
      };
    };
  };
}

function CashboxReceipt(Props) {
  return Curry._2(make(Props.org)(Props.receipt), Props.onStartOverClicked, Props.kkm);
}

const make$1 = CashboxReceipt;

export {
  make$1 as make,
}
/* Buhta_cabinet__Button Not a pure module */
